import { useEffect, useState } from 'react';
import { Marker, useMap as useLeaflet } from 'react-leaflet';

import { CircularProgress } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import L from 'leaflet';

import { colors, GpsIcon } from '@cobliteam/base-components';

import Alert from '@cobliteam/ui/components/Alert';

import ControlButton from '../ControlButton/ControlButton';

export enum MyLocationStatus {
  LOADING = 'LOADING',
  ENABLE = 'ENABLE',
  DISABLE = 'DISABLE',
}

export type TMyLocationIcon = { [key in MyLocationStatus]: JSX.Element };
export type TMyLocationActions = { [key in MyLocationStatus]: () => void };

const MAX_ZOOM_AFTER_SET_POSITION = 16;

const icon = new L.Icon({
  iconUrl: '/static/images/map_icon_with_shadow.png',
});

interface MyLocationControlProps {
  onClick?: (newStatus: MyLocationStatus) => void;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
const MyLocationControl = ({ onClick }: MyLocationControlProps) => {
  const [latlng, setLatlng] = useState<L.LatLngExpression | undefined>(undefined);
  const [state, setState] = useState<MyLocationStatus>(MyLocationStatus.DISABLE);
  const map = useLeaflet();

  if (!Map) {
    return null;
  }

  const getMyLocation = () => {
    const newStatus = state === MyLocationStatus.ENABLE ? MyLocationStatus.DISABLE : MyLocationStatus.LOADING;
    setState(newStatus);
    if (onClick) {
      onClick(newStatus);
    }
  };

  const onFindLocation = ({ latlng: current }: L.LocationEvent) => {
    setLatlng(current);
    setState(MyLocationStatus.ENABLE);
  };

  const onNotFoundLocation = (e: L.ErrorEvent) => {
    Alert.error('Erro de geolocalização: geolocalização negada pelo usuário.');
    setState(MyLocationStatus.DISABLE);
  };

  const myLocationIcon: TMyLocationIcon = {
    [MyLocationStatus.LOADING]: <CircularProgress size={16} color='inherit' />,
    [MyLocationStatus.ENABLE]: <GpsIcon color={colors.primary.default} />,
    [MyLocationStatus.DISABLE]: <GpsIcon color={colors.gray.dark} />,
  };

  const dispatchActions: TMyLocationActions = {
    [MyLocationStatus.LOADING]: () => map.locate({ setView: true, maxZoom: MAX_ZOOM_AFTER_SET_POSITION }),
    [MyLocationStatus.ENABLE]: () => setLatlng(latlng),
    [MyLocationStatus.DISABLE]: () => setLatlng(undefined),
  };

  useEffect(() => {
    dispatchActions[state]();
  }, [state]);

  useEffect(() => {
    map.on('locationfound', onFindLocation);
    map.on('locationerror', onNotFoundLocation);

    return () => {
      map.off('locationfound');
      map.off('locationerror');
    };
  }, []);

  return (
    <Box width='30px' className='leaflet-control'>
      <ControlButton Icon={myLocationIcon[state]} selected={state === MyLocationStatus.ENABLE} onClick={getMyLocation} />
      {latlng && <Marker position={latlng} icon={icon} />}
    </Box>
  );
};

export default MyLocationControl;
